export default __webpack_public_path__ + "static/media/Hypersonic.0ad9ddd7.png";